import formatHelper from "../helper/format-helper";
import { STORE_COMMIT, STORE_GETTER } from "../store/store";




export const routerMixin = {

	computed: {

		



	},

	methods: {

		routerShowStart(){

			console.log('FP: routerMixin: routerShowStart:');

			const productType = this.$store.getters[STORE_GETTER.PRODUCT_TYPE_SELECTED];


			if (productType?.urlKey){
				this.$router.push({ name: "StartView", params: { productTypeKey: productType.urlKey } })
			}else{
				this.$router.push({ name: "StartView", params: { } })
			}
			



		},

		routerShowReseller(){
			this.$router.push("/aterforsaljare")
		},

		routerShowProductDetails(product) {

			console.log('FP: routerMixin: routerShowProductDetails:');

			//alert("xx");
			

			var productType = this.productTypeSelected;



			if (!productType) {
				productType = this.$store.getters[STORE_GETTER.PRODUCT_TYPE_MODEL]?.list?.find(productType => productType.pt == product.pt);
			}


			var urlKey = formatHelper.urlProductKey(product.name);


			//this.$router.push("/" + productType.urlKey + '/product/' + product.productId + "/" + urlKey)
			this.$router.push({ name: "ProductDetails", params: { productTypeKey: productType.urlKey, productId: product.productId, urlKey: urlKey}})
		},

		routerShowProductList(){
			const productTypeModel = this.$store.getters[STORE_GETTER.PRODUCT_TYPE_MODEL];

			if (!productTypeModel.selected){
				alert("Välj produkttyp");
				return;
			}

			this.$router.push("/" + productTypeModel.selected.urlKey + "/products");

			console.log('FP: routerMixin: routerShowProductList: productTypeModel:', productTypeModel);
			
			//alert("routerShowProductList");
		},

		routerShowProductListForUrlKey(urlKey) {
		

			this.$router.push("/" + urlKey + "/products");

			console.log('FP: routerMixin: routerShowProductList: routerShowProductListForUrlKey:', urlKey);

			//alert("routerShowProductList");
		},

		routerReplaceProduct(product){

			var urlKey = formatHelper.urlProductKey(product.name);

			var params = { ...this.$router.currentRoute?.value.params, productId: product.productId, urlKey: urlKey }
			this.$router.replace({ name: "ProductDetails", params: params })

		},

		routerSetupStartUrl(){
			this.routerProductTypeKey({resetIfNull: true});
		},

		routerSetupProductsUrl(){
			this.routerProductTypeKey({ resetIfNull: false });

		},

		routerSetupProductUrl(){

			this.routerProductTypeKey({ resetIfNull: false });

		},

		routerProductTypeKey({resetIfNull}){

			//lert(resetIfNull);

			if (this.productTypeKey) {

				const productTypeModel = this.$store.getters[STORE_GETTER.PRODUCT_TYPE_MODEL];
				const productType = productTypeModel.list?.find(productType => productType.urlKey == this.productTypeKey.toLowerCase());

				if (productType) {
					this.$store.commit(STORE_COMMIT.SELECT_PRODUCT_TYPE, productType)
				}
			}else if(resetIfNull){ // låter annars pt vara på gällande värde
				this.$store.commit(STORE_COMMIT.SELECT_PRODUCT_TYPE, null)
			}
			

		},

		routerReplaceQueryParameter(query){

			const name = this.$route.name;
			//var query = this.$route.query;

			console.log('FP: routerReplaceQueryParameter query: ', query);
			

			this.$router.replace({ name: name, query: query }) 

		},

		isOnProductListPage() {
			return this.$route.name == "Products";


		}








	}
}

/*

router.push({ name: 'user', params: { username: 'eduardo' } })

// named route with params to let the router build the url
router.push({ name: 'user', params: { username: 'eduardo' } })

if (productType) {
					params = { ...this.$router.currentRoute?.value.params, productTypeKey: productType.urlKey }
				} else {
					params = { ...this.$router.currentRoute?.value.params, productTypeKey: null }
				}

				console.log('FP: watcher: productTypeSelected', productType);
				console.log('FP: watcher: productTypeSelected params: ', params);


				this.$router.replace({ name: this.$route.name, params: params });



*/

